module.exports = __webpack_public_path__ + "static/Lacoste-7dfbf6517c338375930e6701d6bce2d0.svg";